var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.icons, function (icon, index) {
    return _c('v-icon', {
      key: "icon-".concat(index),
      staticClass: "ma-3 icon",
      class: {
        'active': _vm.selectedIcon == '$' + icon
      },
      attrs: {
        "large": ""
      },
      on: {
        "click": function click($event) {
          return _vm.selectIcon(icon);
        }
      }
    }, [_vm._v("$" + _vm._s(icon))]);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }